import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'people-page',
    templateUrl: './people-page.component.html',
    styleUrls: ['./people-page.component.less'],
    standalone: false
})
export class PeoplePageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
